if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      this.errorContainer = this.querySelector('[data-error-message]');
      this.cart = document.querySelector('cart-drawer');
    }

    connectedCallback() {
      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }
    }

    async onSubmit(event) {
      event.preventDefault();

      if (this.submitButton?.disabled) return;

      this.setLoading(true);
      this.clearError();
      this.openCartWithLoading();

      const payload = this.buildPayload();

      try {
        const data = await this.addToCart(payload);

        if (this.isErrorResponse(data)) {
          this.handleError(data);
          return;
        }

        this.handleSuccess(data, payload);
      } catch (error) {
        this.handleFetchError(error);
      } finally {
        this.setLoading(false);
      }
    }

    openCartWithLoading() {
      if (this.cart) {
        this.cart.setLoading(true);
        this.cart.open();
      }
    }

    buildPayload() {
      const payload = {
        items: [
          {
            id: this.form.querySelector('[name="id"]')?.value,
            quantity: parseInt(this.form.querySelector('[name="quantity"]')?.value || '1', 10),
          },
        ],
      };

      if (this.cart?.getSectionsToRender) {
        payload.sections = this.cart.getSectionsToRender().map(({ id }) => id).join(',');
        payload.sections_url = window.Shopify.routes.root;
      }

      return payload;
    }

    async addToCart(payload) {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      let data = null;
      try {
        data = await response.json();
      } catch (_) {
        data = null;
      }

      if (!response.ok) {
        const fallback = response.status === 429
          ? 'Too many requests. Please wait a moment and try again.'
          : `Error adding to cart (${response.status})`;
        return {
          status: response.status,
          description: data?.description || data?.message || fallback,
          message: data?.message,
          errors: data?.errors,
        };
      }

      return data;
    }

    isErrorResponse(data) {
      return !!data.status;
    }

    handleError(data) {
      this.cart?.setLoading(false);
      this.cart?.close();
      this.showError(data.description || data.message);

      theme.pubsub.publish(theme.pubsub.events.CART_ERROR, {
        source: 'product-form',
        errors: data.errors || data.description,
        message: data.message,
      });
    }

    handleSuccess(data, payload) {
      if (this.cart?.renderContents) {
        this.cart.renderContents(data);
      }
      this.cart?.setLoading(false);

      theme.pubsub.publish(theme.pubsub.events.CART_UPDATE, {
        source: 'product-form',
        productVariantId: payload.items[0].id,
        cartData: data,
        skipFetch: true,
      });
    }

    handleFetchError(error) {
      console.error('Error adding to cart:', error);
      this.cart?.setLoading(false);
      this.cart?.close();
      this.showError(theme.locales?.cart?.error || 'Error adding to cart');
      theme.pubsub.publish(theme.pubsub.events.CART_ERROR, { error });
    }

    setLoading(isLoading) {
      if (!this.submitButton) return;

      this.submitButton.disabled = isLoading;
      this.submitButton.classList.toggle('loading', isLoading);
    }

    showError(message) {
      if (!this.errorContainer) return;

      this.errorContainer.textContent = message;
      this.errorContainer.hidden = false;
    }

    clearError() {
      if (!this.errorContainer) return;

      this.errorContainer.textContent = '';
      this.errorContainer.hidden = true;
    }
  }

  customElements.define('product-form', ProductForm);
}
